export const cognitoErrorMap: Record<string, string> = {
  NotAuthorizedException: 'E-mail ou senha incorretos.',
  UserNotFoundException: 'Usuário não encontrado.',
  UsernameExistsException: 'Já existe uma conta com este e-mail.',
  InvalidPasswordException: 'A senha não atende aos requisitos de segurança.',
  InvalidParameterException: 'Parâmetro inválido. Verifique os dados informados.',
  CodeMismatchException: 'Código de verificação inválido.',
  ExpiredCodeException: 'O código de verificação expirou. Solicite um novo.',
  LimitExceededException: 'Limite de tentativas excedido. Tente novamente mais tarde.',
  TooManyRequestsException: 'Muitas requisições. Aguarde um momento e tente novamente.',
  TooManyFailedAttemptsException: 'Muitas tentativas incorretas. Tente novamente mais tarde.',
  UserNotConfirmedException: 'Sua conta ainda não foi confirmada. Verifique seu e-mail.',
  PasswordResetRequiredException: 'É necessário redefinir sua senha.',
  UserLambdaValidationException: 'Erro de validação. Entre em contato com o suporte.',
  NetworkError: 'Erro de conexão. Verifique sua internet e tente novamente.',
};

export function translateCognitoError(e: any, fallback: string): string {
  const code = e?.code || e?.name || e?.__type || '';
  return (code && cognitoErrorMap[code]) ? cognitoErrorMap[code] : fallback;
}
